import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function AboutPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900">
      <header className="fixed top-0 w-full bg-black/50 backdrop-blur-md border-b border-gray-800">
        <nav className="container mx-auto px-4 py-4 flex justify-between items-center">
          <div 
            onClick={() => navigate('/')}
            className="text-2xl font-bold bg-gradient-to-r from-purple-400 to-pink-600 text-transparent bg-clip-text cursor-pointer"
          >
            Verdyct
          </div>
          <div className="space-x-4">
            <button 
              onClick={() => navigate('/login')}
              className="px-4 py-2 text-gray-300 hover:text-white transition-colors"
            >
              Log in
            </button>
            <button 
              onClick={() => navigate('/signup')}
              className="px-4 py-2 bg-gradient-to-r from-purple-500 to-pink-600 rounded-lg text-white hover:opacity-90 transition-opacity"
            >
              Sign up
            </button>
          </div>
        </nav>
      </header>

      <main className="container mx-auto px-4 pt-32 pb-20">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 bg-gradient-to-r from-purple-400 via-pink-500 to-red-500 text-transparent bg-clip-text">
            About Verdyct
          </h1>
          
          <div className="space-y-8 text-gray-300">
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Our Mission</h2>
              <p>
                Verdyct was born from a simple yet powerful observation: the best way to understand any topic is to examine it from multiple perspectives. In a world of increasing complexity and polarization, we needed a tool that could help us see beyond our own viewpoints and biases.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Why Two AI Agents?</h2>
              <p>
                Traditional AI assistants often provide single, authoritative answers that can oversimplify complex issues. By having two AI agents engage in structured debate, we create a dynamic where each perspective is thoroughly examined and challenged. This approach helps uncover nuances, potential flaws in reasoning, and leads to more comprehensive understanding.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">The Power of Dialectic</h2>
              <p>
                Our approach is inspired by the Socratic method and Hegelian dialectic - the idea that truth emerges through the conflict and resolution of opposing ideas. Each debate is structured to help users:
              </p>
              <ul className="list-disc ml-6 mt-4 space-y-2">
                <li>Understand multiple viewpoints</li>
                <li>Identify stronger and weaker arguments</li>
                <li>Consider counterarguments they might have missed</li>
                <li>Reach more nuanced and balanced conclusions</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Our Vision</h2>
              <p>
                We envision Verdyct as more than just a question-answering tool. It's a platform for deeper understanding, better decision-making, and intellectual growth. Whether you're exploring complex philosophical questions, analyzing policy decisions, or weighing personal choices, our AI debate system helps you consider all angles and arrive at well-reasoned conclusions.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Join Us</h2>
              <p>
                We believe that better reasoning leads to better decisions, and better decisions lead to better outcomes. Join us in this journey to explore ideas more deeply and make more informed choices through the power of AI-driven dialectic discourse.
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
}